import { Component, OnInit, Output,EventEmitter,Inject,OnDestroy, HostListener } from '@angular/core';
import {map, startWith} from 'rxjs/operators';
import { Router } from '@angular/router'
import { ApiService } from '../api.service'
import { ObservablesService } from '../observables.service'
import { FormBuilder,FormControl, Validators, FormGroup, FormGroupDirective, NgForm } from '@angular/forms';
import {Observable} from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}
@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {
  @Output() onDataChanged: EventEmitter<any> = new EventEmitter<any>();
  // @Output() onTagChanged: EventEmitter<any> = new EventEmitter<any>();
  dataForm:FormGroup
  unitFormStatus:boolean = true;
  h_level:any=[];
  business_id : any;
  myControl = new FormControl('');
  myControl1 = new FormControl('');
  parties:any = []
  options:any = []
  options1:any = []
  filteredOptions: Observable<string[]>;
  filteredOptions1: Observable<string[]>;
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  selectedDateRange:Date[]
  loggedUserInfo:any;
  selectedUserData:any=null
  selectedTagData:any=null
  selectedData:any = {selectedParty:null, selectedDates:null, selectedTag:null}
  passwordForm:FormGroup;
  tagForm:FormGroup;
  showPopupStatus:boolean = false
  showTagPopupStatus:boolean = false
  matcher = new MyErrorStateMatcher();
  changePasswordObserver:any;
  getHeaderObserver:any;
  refreshHeaderPartyObserver:any;
  resetPartySearchObserver:any;
  tagPopupObserver:any;
  tagPopupStatus:boolean = false
  editTagStatus:boolean = false
  mb_tag_status:boolean = false
  tagEditId:any='';
  tags:any=[]
  profileUpdateSubscriber:any;
  constructor(private router:Router, private observables:ObservablesService, private api:ApiService,private fb:FormBuilder) {
    this.maxDate.setDate(this.maxDate.getDate() - 180);
    this.bsRangeValue = [this.maxDate,this.bsValue];
    this.selectedDateRange = [this.maxDate,this.bsValue];
    this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
      // console.log("this.bsRangeValuess=",this.bsRangeValue)
      this.changePasswordObserver = this.observables.changePasswordStatus.subscribe(()=>{
        this.showPopupStatus = true
      })

      this.tagPopupObserver = this.observables.tagPopupStatus.subscribe(()=>{
        this.showTagPopupStatus = true
        this.getTags()
      })
      this.passwordForm = this.fb.group({
        old_password:['',Validators.compose([Validators.required])],
        new_password:['',Validators.compose([Validators.required])],
        confirm_password:['']
      },{validator: this.checkPasswords });

      this.tagForm = this.fb.group({
        tag_name:['',Validators.compose([Validators.required])]
      });
    }

    showTagBlock(){
      this.mb_tag_status = !this.mb_tag_status
      // this.myControl.patchValue('')
      // this.myControl1.patchValue('')
    }

    getTags(){
     this.api.send("findDb",{
       table:"tags",
       conditions:[{business_id:this.loggedUserInfo.business_id}]
     }).then((result:any)=>{
       this.tags=result.data
       this.options1 = result.data;
       this.filteredOptions1 = this.myControl1.valueChanges
       .pipe(
         startWith(''),
         map(value => this._filter1(value))
       );
        // console.log("this.filteredOptions1===",this.filteredOptions1)
     })
    }
    private _filter1(value: string): string[] {
      // console.log("value==",value)

      if(value == ''){
        this.selectedTagData = null;
        this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.bsRangeValue, selectedTag:this.selectedTagData}
        this.onDataChanged.emit(this.selectedData);
      }
      if(value){

        const filterValue = value.toLowerCase();
        return this.options1.filter(option => option.tag_name.toLowerCase().includes(filterValue));
      }
    }

    onSelectionChanged1(_event: any,userData) {

      if (_event.isUserInput) {
        // console.log("selected tag=",userData)
         this.selectedTagData= userData;
         this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
         this.onDataChanged.emit(this.selectedData);
         // this.onTagChanged.emit(userData)
      }

    }

    editTag(tag){
      this.tagEditId = tag.id;
      this.tagForm.patchValue({tag_name:tag.tag_name});
      this.editTagStatus = true;
    }
    cancelEdit(){
      this.tagEditId = '';
      this.tagForm.reset();
      this.editTagStatus = false;
    }

    updateTag(value){
      if(confirm("Are you sure to Update Tag ?")){
        this.api.send("findDb",{
          table:'tags',
          conditions:[{tag_name:value.tag_name,business_id:this.loggedUserInfo.business_id}]
        }).then((res:any)=>{
          if(res.data.length > 0){
            this.observables.showToastMessage({type:1,message:"Tag Name Already Exists."})
          }else{
            this.api.send("updateDb",{
              table:'tags',
              data:{tag_name:value.tag_name},
              conditions:[{id:this.tagEditId,business_id:this.loggedUserInfo.business_id}]
            }).then((res1:any)=>{
              if(res1.data.affectedRows){
                // this.tagForm.reset()
                this.getTags()
                this.cancelEdit()
                this.observables.showToastMessage({type:0,message:"Tag Updated.."})
                this.observables.refreshTagsStatus.next()
              }else{

                this.observables.showToastMessage({type:1,message:"Can\'t update tag, Try again."})
              }
            })
          }
        })
      }
    }

    deleteTag(id){
      if(confirm("Are you sure to delete Tag ?")){

        this.api.send("deleteDb",{
          table:'tags',
          conditions:[{id:id,business_id:this.loggedUserInfo.business_id}]
        }).then((res1:any)=>{
          if(res1.data.affectedRows){
            this.getTags()
            this.observables.showToastMessage({type:0,message:"Tag Deleted.."})
            this.observables.refreshTagsStatus.next()
          }else{

            this.observables.showToastMessage({type:1,message:"Can\'t delete tag, Try again."})
          }
        })
      }
    }



  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
     let pass = group.controls.new_password.value;
     let confirmPass = group.controls.confirm_password.value;

     return pass === confirmPass ? null : { notSame: true }
  }

  ngOnDestroy(){
    this.changePasswordObserver.unsubscribe()
    this.getHeaderObserver.unsubscribe()
    this.profileUpdateSubscriber.unsubscribe()
    // this.refreshHeaderPartyObserver.unsubscribe()
    // this.resetPartySearchObserver.unsubscribe()
  }

  addTag(value){
    // console.log('value==',value)
    this.api.send("findDb",{
      table:'tags',
      conditions:[{tag_name:value.tag_name,business_id:this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      if(res.data.length > 0){
        this.observables.showToastMessage({type:1,message:"Tag Name Already Exists."})
      }else{
        this.api.send("insertDb",{
          table:'tags',
          data:{tag_name:value.tag_name,business_id:this.loggedUserInfo.business_id}
        }).then((res1:any)=>{
          if(res1.data.affectedRows){
            this.tagForm.reset()
            this.getTags()
            this.observables.showToastMessage({type:0,message:"Tag Added.."})
            this.observables.refreshTagsStatus.next()
          }else{
            this.observables.showToastMessage({type:1,message:"Tag Name Already Tag Can\'t Add, Try again."})

          }
        })
      }
    })
  }

  ngOnInit() {

    this.getHeaderObserver = this.observables.getHeaderStatus.subscribe(()=>{
      this.onDataChanged.emit(this.selectedData);
    })

    this.resetPartySearchObserver = this.observables.refreshHeaderPartyStatus.subscribe(()=>{
      this.getParty();
    })

    this.resetPartySearchObserver = this.observables.resetPartySearchStatus.subscribe(()=>{
      this.myControl.patchValue('')
      this.myControl1.patchValue('')
    })

    this.profileUpdateSubscriber = this.observables.profileUpdateStatus.subscribe(()=>{
      this.api.getLoggedUserInfo().then((res:any)=>{
        // console.log("res=",res)
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];

        }else{
          this.api.logOut()
        }
      })

    })



    this.api.getLoggedUserInfo().then((res:any)=>{
      // console.log('logged user info=',res)
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.h_level = Array(this.loggedUserInfo.h_level).fill(0).map((x,i)=>i+1);
        this.getParty();
        this.getTags();
      }else{
        this.api.logOut()
      }
    })
  }

  gotoDashboard(){
    // console.log("clicke in header")
    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
    // if(this.router.url !='/admin/add-user'){
    //   if(this.loggedUserInfo.level == 1){
    //
    //     this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/admin-dashboard')])
    //   }else{
    //
    //   }
    // }

    this.observables.showMobileDashboardStatus.next()

  }

  closeTagModel(){
    this.showTagPopupStatus = false;
  }


  getParty(){
    return new Promise((resolve)=>{
    this.api.send("findDb",{
      table:"parties",
      conditions:[{business_id:this.loggedUserInfo.business_id}],
      order:"id DESC"
    }).then((res:any)=>{
      this.parties = res.data;
      this.options = res.data;
      this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    })
   })
  }

  private _filter(value: string): string[] {
    // console.log("value==",value)

    if(value == ''){
      this.selectedUserData = null;
      this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.bsRangeValue, selectedTag:this.selectedTagData}
      this.onDataChanged.emit(this.selectedData);
    }

    if(value){

      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.business_name.toLowerCase().includes(filterValue));
    }
  }

  onSelectionChanged(_event: any,userData) {

    if (_event.isUserInput) {

       this.selectedUserData= userData;
       this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
       this.onDataChanged.emit(this.selectedData);
    }

  }

  onValueChange(event){
    // console.log("this.bsRangeValue=",event)
    if(event){
      this.selectedDateRange = event;
      this.selectedData = {selectedParty:this.selectedUserData, selectedDates:this.selectedDateRange, selectedTag:this.selectedTagData}
      this.onDataChanged.emit(this.selectedData);
    }
  }

  openMenu(){
    this.observables.setMenuStatus({menuState:'in'})
  }

  closeModel(){
    this.showPopupStatus = false;
    this.passwordForm.reset();
  }

  updatePassword(value){
    // console.log("form value=",value)
    if(confirm("Are you sure to change Password?")){

      this.api.send("findDb",{
        table:"users",
        conditions:[{password:value.old_password, business_id:this.loggedUserInfo.business_id, id:this.loggedUserInfo.id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.api.send("updateDb",{
            table:"users",
            data:{
              password:value.confirm_password
            },
            conditions:[{password:value.old_password, business_id:this.loggedUserInfo.business_id, id:this.loggedUserInfo.id}]
          }).then((updateRes:any)=>{
            if(updateRes.data.affectedRows){
              this.passwordForm.reset();
              this.observables.showToastMessage({type:0,message:"Password Updated Successfully...!"})
            }else{
              this.observables.showToastMessage({type:1,message:"Can\'t Update Password, Try again...!"})
            }
          })
        }else{
          this.observables.showToastMessage({type:1,message:"Invalid Current Password...!"})
        }
      })
    }
  }

}
